export const USERDATA_ARROW = 'arrow'
export const USERDATA_WALL = 'notTouchable'
export const USERDATA_PILLAR = 'touchable'
